import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "updated",
    title: _ctx.absoluteTime
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["updated-dot", _ctx.freshness])
    }, null, 2),
    _createTextVNode("最后更新 · " + _toDisplayString(_ctx.timeSince), 1)
  ], 8, _hoisted_1))
}